import styles from "./DetalhesColeta.module.css";
import Container from "../../../components/components-ui/Container/Container";
import Button from "../../../components/components-ui/Button/Button";
import api from "../../../services/Api";
// import Loading from '../../../components/components-ui/Loading/Loading'
import { BlockScreenLoading } from "../../../components/BlockScreenLoading";

import convert from "../../../utils/imageFileResize";
import { Link } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, Fragment, useContext } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Select from "react-select";
import { defaultStyle } from "../../../components/components-ui/SelectSearch/SelectSearch";
import { toast } from "react-toastify";
import { ProdutosMotoristaContext } from "../../../Provider/ProdutosMotoristaContext";

function DetalhesColeta() {
  const navigate = useNavigate();
  const { setItensContrapartida, itensContrapartida } = useContext(
    ProdutosMotoristaContext,
  );

  const { id } = useParams();
  const [infoDetalheColeta, setInfoDetalheColeta] = useState([]);
  const [valorKG, setValorKG] = useState("");
  const [valorDinheiro, setValorDinheiro] = useState("");
  const [observacao, setObservacao] = useState("");
  // const [showLoading, setShowLoading] = useState(false)
  const [images, setImages] = useState(null);
  const [previewPhotos, setPreviewPhotos] = useState([]);
  const [listaDeImagens, setListaDeImagens] = useState([]);
  const [blockScreen, setBlockScren] = useState(false);
  const [idColeta, setIdColeta] = useState("");
  const [idOcSub, setIdOcSub] = useState("");
  const [idOc, setIdOc] = useState("");
  const [formaDePagamento, setFormadepagamento] = useState([]);
  const [preColeta, setPreColeta] = useState([]);
  const [dadosListaColetaSub, setDadosListaColetaSub] = useState([]);

  const [produtosCadastro, setProdutosCadastro] = useState([]);

  const [selectedOptionPagamento, setSelectedOptionPagemento] = useState(null);

  //Certificado
  const [certificado, setCertificado] = useState([]);
  const [selectOptionCertificado, setSelectOptionCertificado] = useState(null);

  const handleChangePagamento = (selectedOption) => {
    // console.log(selectedOption);
    // setSelectedOptionPagemento(selectedOption); para react select
    setSelectedOptionPagemento(selectedOption);
  };

  const handleChangeCertificado = (selectedOption) => {
    // setSelectOptionCertificado(selectedOption); para react select
  };

  function back() {
    const { id_oc } = infoDetalheColeta;
    setItensContrapartida([]);
    navigate(`/local/listagem-de-coletas/${id_oc}`);
  }

  async function getFormaDePagamento() {
    const response = await api.get(`/formadepagamento`);
    setFormadepagamento(response.data);
  }

  //Buscar os certificados
  async function getCertificados(id) {
    const response = await api.post(`/motorista/listaroteirocertificado/${id}`);
    setCertificado(response.data.data);
  }

  async function getPreColeta(idOcSub) {
    try {
      const response = await api.get(`/motorista/showcoleta/${idOcSub}`);
      if (response.data.error === 0) {
        setPreColeta(response.data.coleta);
        setProdutosCadastro(response.data.coleta_contrapartida);
        setDadosListaColetaSub(response.data.coleta_sub);
        setIdColeta(response.data.coleta.IDColeta);
        await getImagensColeta(response.data.coleta.IDColeta);
      } else {
        setPreColeta([]);
        setProdutosCadastro([]);
        setDadosListaColetaSub([]);
        setIdColeta("");
      }
    } catch (error) {
      console.log(error);
    }

    // if (response.data.length > 0) {
    //   setValorKG(response.data.VolumeOleoColetado)
    // }
  }

  useEffect(() => {
    async function carregarDados() {
      try {
        setBlockScren(true);

        const response = await api.post(
          `/motorista/roteirodetalhecoleta/${id}`,
        );
        setInfoDetalheColeta(response.data);

        setIdOcSub(response.data.id_oc_sub);
        setIdOc(response.data.id_oc);
        // setIdColeta(response.data.id_oc);
        // getCertificados(response.data.id_oc_sub);

        await getPreColeta(response.data.id_oc_sub);
        await getFormaDePagamento();
      } catch (err) {
        console.log(err);
      } finally {
        setBlockScren(false);
      }
    }

    carregarDados();
  }, []);

  async function getImagensColeta(idColeta) {
    setBlockScren(true);
    if (idColeta) {
      await api
        .post(`motorista/roteirodetalhecoletaimg/${idColeta}`)
        .then((res) => {
          if (res.data.error === 0) {
            setListaDeImagens(res?.data?.serializedImg);
          }
          if (res.data.error === 1) {
            console.log(res.data.msg);
          }
        })
        .catch((error) => {
          toast.error("Erro ao buscar imagens");
        });

      setBlockScren(false);
    }
  }

  async function IrProdutos() {
    navigate(`/local/detalhe-coleta-produtos/${id}`);
  }

  async function IrColetaNaoTemOleo() {
    navigate(`/local/coleta-nao-tem-oleo/${id}`);
  }

  async function criarColeta() {
    const dadosColeta = {
      IdFormaPagamento: selectedOptionPagamento || null,
      IDLocal: infoDetalheColeta.IDlocal,
      IDOC: idOc,
      ValorPagamento: valorDinheiro,
      Observacoes: observacao,
      IdOcSub: idOcSub,
      IdColetasOc: idOc,
      // IdCertificado: selectOptionCertificado || null,
    };

    if (!selectedOptionPagamento) {
      return confirmAlert({
        message: "Preencha a forma de pagamento !!!",
        buttons: [
          {
            label: "Fechar",
          },
        ],
      });
    }

    if (valorKG <= 0) {
      return confirmAlert({
        message: "Preencha o campo de quantidade de óleo !!!",
        buttons: [
          {
            label: "Fechar",
          },
        ],
      });
    }

    const data = {
      ...dadosColeta,
      coletasub: [{ IDItem: 1, Quantidade: valorKG }],
      contraPartida: itensContrapartida,
    };

    setBlockScren(true);
    try {
      const response = await api.post(`/freguesia/criarcoletafreguesia`, data);

      setBlockScren(false);
      if (response.data.error === 1) {
        toast.error(response.data.msg ?? "Erro ao Salvar");
        return;
      }

      //Salvar imagens na coleta
      if (images?.length) {
        await uploadImages(response.data.IDColeta);
      }

      setValorKG("");
      setItensContrapartida([]);
      toast.success("Salvo com sucesso!", { autoClose: 3000 });

      const id_oc = infoDetalheColeta?.id_oc;
      navigate(`/local/listagem-de-coletas/${id_oc}`);
    } catch (error) {
      console.log(error);
      toast.error("Erro ao salvar. Tente novamente.");
    } finally {
      setBlockScren(false);
    }
  }

  async function avisoOcorrenciaColeta() {
    const data = {
      id_coleta: idColeta,
      id_oc_sub: idOcSub,
      id_oc: idOc,
    };

    const response = await api.post(`/motorista/avisaocorrencia`, data);
    if (response.data.error === 1) {
      return confirmAlert({
        message: "Erro ao salvar",
        buttons: [
          {
            label: "Fechar",
          },
        ],
      });
    } else {
      const id_oc = infoDetalheColeta?.id_oc;
      navigate(`/local/listagem-de-coletas/${id_oc}`);
      window.open("https://chat.whatsapp.com/IYFm1MzQKK0AOTcH5F0tHo", "_blank");
    }
  }

  async function uploadImages(idColeta) {
    setBlockScren(true);

    const id_oc_sub = infoDetalheColeta?.id_oc_sub;
    const formData = new FormData();

    const convertedImages = await Promise.all(
      images.map(async (img) => {
        const converted = await convert({
          file: img,
          type: "jpeg",
        });

        return converted;
      }),
    );

    images.forEach((file) => {
      formData.append("images", file);
    });

    const response = await api
      .post(`/motoristauploadimagemcoleta/${idColeta}`, formData)
      .then((res) => {
        setBlockScren(false);
        if (res.data.error === 0) {
          setImages(null);
          getImagensColeta(idColeta);
        }
      })
      .catch((error) => {
        setImages(null);
        setBlockScren(false);
        toast.error(
          "Algo de errado aconteceu ao fazer o upload da imagem! " + error,
        );
      });
  }

  function previewImg(ev) {
    if (ev.target.files) {
      const files = Array.from(ev.target.files);
      setImages(files);
      const urls = files.map((file) => URL.createObjectURL(file));
      setPreviewPhotos(urls);
      return;
    }
    setPreviewPhotos([]);
    setImages(null);
  }

  function removerImagemDaLista(indexToRemove) {
    const updatedImages = images.filter((_, index) => index != indexToRemove);
    const updatedPreviews = previewPhotos.filter(
      (_, index) => index != indexToRemove,
    );

    setImages(updatedImages);
    setPreviewPhotos(updatedPreviews);
  }

  async function coletaNãoRealizada() {
    // id = id_oc_sub
    const response = await api.post(`/motorista/coletanaorealizada/${id}`);
    console.log(response);
    if (response.data.error === 1) {
      confirmAlert({
        message: "Erro na ação !",
        buttons: [
          {
            label: "Fechar",
          },
        ],
      });
      return;
    }
    back();
    // confirmAlert({
    //   message: 'Ação executada com sucesso !',
    //   buttons: [
    //   {
    //     label: 'Fechar',
    //   }
    // ]
    // }
  }

  async function EntregaRetiraMaterialColeta() {
    // id = id_oc_sub
    const response = await api.post(
      `/motorista/validaentregaretiramaterial/${id}`,
    );
    console.log(response);
    if (response.data.error === 1) {
      confirmAlert({
        message: "Erro na ação !",
        buttons: [
          {
            label: "Fechar",
          },
        ],
      });
      return;
    }
    back();
    // confirmAlert({
    //   message: 'Ação executada com sucesso !',
    //   buttons: [
    //   {
    //     label: 'Fechar',
    //   }
    // ]
    // })
  }

  return (
    <Container>
      <BlockScreenLoading loading display={blockScreen}>
        <strong> Carregando... </strong>
      </BlockScreenLoading>

      <div className={styles.content}>
        <div className={styles.btn_footer}>
          <Link
            to={`/local/listagem-de-coletas/${infoDetalheColeta?.id_oc}`}
            onClick={back}
            className={styles.backButton}
          >
            <i className="fas fa-arrow-left"></i> Voltar
          </Link>
        </div>

        <>
          <h3>Detalhes da Freguesia: {infoDetalheColeta?.id_coleta}</h3>
          <section className={styles.wrap_coleta}>
            {/* Listagem */}
            <ul>
              <li>
                <strong>Codigo</strong>: {infoDetalheColeta?.Codigo}
              </li>

              <li>
                <strong>Marca</strong>: {infoDetalheColeta?.nome_local}
              </li>
              <li>
                <strong>Data Ultima Coleta</strong>:{" "}
                {infoDetalheColeta?.DataUltimaColeta}
              </li>
              <li>
                <strong>Endereço</strong>: {infoDetalheColeta?.endereco}
              </li>
              <li>
                <strong>Bairro</strong>: {infoDetalheColeta?.Bairro}
              </li>
              <li>
                <strong>Cidade</strong>: {infoDetalheColeta?.Cidade}
              </li>
              <li>
                <strong>Valor Kg.</strong>:{" "}
                {infoDetalheColeta?.Valorkgcontrapartida}
              </li>
            </ul>
            <div className={styles.detalhe_coleta}>
              {/* Formulario */}
              <form
                enctype="multipart/form-data"
                onSubmit={(ev) => ev.preventDefault()}
                className={styles.form_detalheColeta}
              >
                {/* {values?.bloqueado === 0 ? ( */}
                <>
                  <div>
                    <label className={styles.label} htmlFor="formaDePagamento">
                      Forma de Pagamento
                    </label>
                    {preColeta && Object.keys(preColeta).length > 0 ? (
                      <input
                        type="text"
                        className={styles.input}
                        value={preColeta.TipoPagamento}
                        disabled
                      />
                    ) : (
                      <select
                        id="formaDePagamento"
                        value={preColeta?.IdFormaPagamento}
                        onChange={(e) => handleChangePagamento(e.target.value)}
                        required
                      >
                        <option value="">Selecione Forma de Pagto</option>
                        {formaDePagamento.map((option) => (
                          <option key={option.Id} value={option.Id}>
                            {option.TipoPagamento}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                  {/* <div>
                      <label className={styles.label} htmlFor="certificado">
                        Certificado
                      </label>
                      {preColeta.length ? (
                        <input
                          type="text"
                          className={styles.input}
                          value={preColeta[0].IdCertificado}
                          disabled
                        />
                      ) : (
                        // <Select
                        //   options={certificado.map((values) => ({
                        //     value: values?.IdCertificados,
                        //     label: values?.NumeroCertificado,
                        //   }))}
                        //   value={selectOptionCertificado}
                        //   onChange={handleChangeCertificado}
                        //   name="certificado"
                        //   styles={defaultStyle}
                        //   placeholder="Selecione o certificado"
                        //   isClearable
                        // />
                        <select
                          id="certificado"
                          value={selectOptionCertificado}
                          onChange={(e) =>
                            handleChangeCertificado(e.target.value)
                          }
                        >
                          <option value="">Selecione o certificado</option>
                          {certificado.map((option) => (
                            <option
                              key={option.IdCertificados}
                              value={option.IdCertificados}
                            >
                              {option.NumeroCertificado}
                            </option>
                          ))}
                        </select>
                      )}
                    </div> */}
                  <div>
                    <label className={styles.label} htmlFor="estimativaOleo">
                      QTDE. de Óleo
                    </label>
                    <input
                      type="number"
                      placeholder="QTDE"
                      className={styles.input}
                      value={
                        preColeta && Object.keys(preColeta).length > 0
                          ? dadosListaColetaSub[0]?.estimativa_ligacao
                          : valorKG
                      }
                      required
                      onChange={(e) => setValorKG(e.target.value)}
                      name="estimativaOleo"
                      id="estimativaOleo"
                      disabled={preColeta && Object.keys(preColeta).length > 0}
                    />
                  </div>
                  <div>
                    <label className={styles.label} htmlFor="valorDinheiro">
                      Valor em dinheiro
                    </label>
                    <input
                      type="number"
                      placeholder="Valor em Dinheiro"
                      className={styles.input}
                      value={
                        preColeta && Object.keys(preColeta).length > 0
                          ? parseFloat(preColeta?.ValorPagamento).toFixed(2)
                          : valorDinheiro
                      }
                      required
                      onChange={(e) => setValorDinheiro(e.target.value)}
                      name="valorDinheiro"
                      id="valorDinheiro"
                      disabled={preColeta && Object.keys(preColeta).length > 0}
                    />
                  </div>

                  {preColeta?.NaoTemOleo === 1 && (
                    <div>
                      <label className={styles.label}>
                        Observação Não Tem Oleo
                      </label>
                      <textarea
                        placeholder="Observação Não Tem Oleo"
                        className={styles.input}
                        value={preColeta?.NaoTemOleoObservacao}
                        disabled
                      />
                    </div>
                  )}

                  <div>
                    <label className={styles.label} htmlFor="observacao">
                      Observação
                    </label>
                    <textarea
                      id="observacao"
                      placeholder="Observação"
                      className={styles.input}
                      value={preColeta?.observacao}
                      onChange={(e) => setObservacao(e.target.value)}
                      disabled={preColeta && Object.keys(preColeta).length > 0}
                    />
                  </div>

                  {/* {values?.bloqueado === 1 ? (
                      <span>
                        <strong>Aviso de ocorrência: </strong>
                        {values?.descricao_ocorrencia}
                      </span>
                    ) : null} */}

                  {infoDetalheColeta?.bloqueado === 0 ? (
                    <section className={styles.wrap_btn_coleta}>
                      <Button title="Salvar Coleta" onClick={criarColeta} />
                      <Button
                        title="Entr./Ret. Material"
                        onClick={EntregaRetiraMaterialColeta}
                        color="blue"
                        type="button"
                      />
                    </section>
                  ) : (
                    <div className={styles.imgBtn}>
                      <section className={styles.wrap_btn_coleta}>
                        <div className={styles.imgBtn}>
                          <label
                            className={styles.labelForImg}
                            htmlFor="selectImg"
                          >
                            <i className="fas fa-camera"></i>
                            Capturar Imagem
                          </label>
                          <input
                            id="selectImg"
                            className={styles.selectImg}
                            type="file"
                            onChange={(ev) => previewImg(ev)}
                            accept="image/*"
                            capture="environment"
                            multiple
                          />
                        </div>
                        {(preColeta && Object.keys(preColeta).length > 0) ||
                        infoDetalheColeta?.NaoTemOleo == 1 ? null : (
                          <>
                            <Button
                              title="Adicionar Produtos"
                              onClick={IrProdutos}
                            />
                            <Button
                              title="Não tem Óleo"
                              color="tertiary"
                              onClick={IrColetaNaoTemOleo}
                            />
                            <Button
                              title="Criar Coleta"
                              onClick={criarColeta}
                            />
                          </>
                        )}
                      </section>
                    </div>
                  )}

                  {produtosCadastro.length > 0 && (
                    <>
                      <span>
                        <strong>Produtos Cadastrados</strong>
                      </span>
                      <table>
                        <thead>
                          <tr>
                            <th>Produto</th>
                            <th>Quantidade</th>
                          </tr>
                        </thead>

                        <tbody>
                          {produtosCadastro.map((item, index) => (
                            <tr key={index}>
                              <td>{item.Brinde}</td>
                              <td>{item.QuantidadeSolicitada}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  )}
                </>
                {/* ) : null} */}
              </form>
              {images && images.length ? (
                <div className={styles.previewImg}>
                  <section className={styles.wrap_coleta}>
                    {previewPhotos.map((photo, index) => (
                      <div className={styles.img_container}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            marginBottom: 8,
                          }}
                          onClick={() => removerImagemDaLista(index)}
                        >
                          <i
                            className="fas fa-times fa-lg"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => removerImagemDaLista(index)}
                          ></i>
                        </div>
                        <img
                          key={index}
                          src={photo}
                          alt="Preview"
                          width="100%"
                        />
                      </div>
                    ))}
                  </section>
                  {idColeta && (
                    <Button
                      color="secondary"
                      title="Salvar Captura"
                      onClick={() => uploadImages(idColeta)}
                    />
                  )}
                </div>
              ) : null}
            </div>
          </section>
        </>

        {/* <div className={styles.loading}>
          <Loading display={showLoading ? 'block' : 'none'} />
        </div> */}

        {listaDeImagens.length !== 0 ? (
          <section className={styles.wrap_coleta}>
            {listaDeImagens.map((values) => (
              <div className={styles.img_container}>
                <img
                  src={values?.image_url}
                  key={values?.id}
                  alt="Photos"
                  width="100%"
                />
              </div>
            ))}
          </section>
        ) : null}
      </div>
    </Container>
  );
}

export default DetalhesColeta;
